import '../../../scss/elements/_flow-bar.scss'

import find from 'lodash/find'
import map from 'lodash/map'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getSelectedFinanziamento } from '../../utils/findomesticUtils'
import { getFromFee, isNltBrumbrum } from '../../utils/nltUtils'
import BuyButton from '../buy/dumb/BuyButton'
import BuyModal from '../buy/dumb/BuyModal'
import BuyRateBox from '../buy/dumb/BuyRateBox'
import { filesBaseUrl, productImagePlaceholder } from '../buy/utils'
import CheckPoint from '../icons/CheckPoint'
import formatCilindrata from '../noleggia/formatCilindrata'

class FlowBar extends Component {
  constructor(props) {
    super(props)

    this.getFeeKm = this.getFeeKm.bind(this)
    this.getKmInclusi = this.getKmInclusi.bind(this)

    numeral.language('it')

    const id_auto = props.product.id_auto || window.brumbrum.id_auto
    this.state = {
      finanziamento_tooltip_modal: false,
      product_image: `${filesBaseUrl}/pictures/${id_auto}/close.27.mid.jpg`,
    }
    this.navigationElements = {
      'rent-noleggio': {
        'scegli-canone': {
          step: 1,
          title: 'Canone',
        },
        'servizi-plus': {
          step: 2,
          title: 'Servizi',
        },
        'richiesta-noleggio': {
          step: 3,
          title: 'Richiesta Noleggio',
        },
        documents: {
          step: 4,
          title: 'Carica Documenti',
        },
      },
      'buy-none': {
        cart: {
          step: 1,
          title: 'Riepilogo ordine',
        },
        servizi: {
          step: 2,
          title: 'Servizi aggiuntivi',
        },
        checkout: {
          step: 3,
          title: 'Checkout',
        },
      },
      'buy-bank': {
        cart: {
          step: 1,
          title: 'Riepilogo ordine',
        },
        checkout: {
          step: 2,
          title: 'Checkout',
        },
        servizi: {
          step: 3,
          title: 'Servizi aggiuntivi',
        },
        dati: {
          step: 4,
          title: 'Passaggio di proprietà',
        },
        contratto: {
          step: 5,
          title: 'Proposta contrattuale',
        },
        bonifico: {
          ignore: ['bonifico-ready-for-docs'],
          step: 6,
          title: 'Pagamento',
        },
        documents: {
          step: 7,
          title: 'Caricamento documenti',
        },
      },
      'buy-finanziamento': {
        cart: {
          step: 1,
          title: 'Riepilogo del tuo ordine',
        },
        checkout: {
          step: 2,
          title: 'Modalità di acquisto',
        },
        servizi: {
          step: 3,
          title: 'Servizi aggiuntivi',
        },
        'dati-finanziamento': {
          step: 4,
          title: 'Richiesta prestito',
        },
        'riepilogo-finanziamento': {
          step: 5,
          title: 'Riepilogo finanziamento',
        },
        documents: {
          step: 6,
          title: 'Upload documenti',
        },
      },
    }
  }

  toggleRateInfo() {
    this.setState({
      finanziamento_tooltip_modal: !this.state.finanziamento_tooltip_modal,
    })
  }

  getFeeKm() {
    if (this.props.nlt && this.props.nlt.defaultCanone) {
      const { fee_km } = this.props.nlt.defaultCanone
      return fee_km ? numeral(fee_km).format('0[.]00') : null
    }

    return null
  }

  getKmInclusi() {
    if (this.props.nlt && this.props.nlt.defaultCanone) {
      const { km_inclusi } = this.props.nlt.defaultCanone
      return km_inclusi ? numeral(km_inclusi).format('0[,]00') : null
    }

    return null
  }

  render() {
    const { product, nlt, flowType, payment, financements, ordine, router } =
      this.props
    if (
      (isNltBrumbrum(product) &&
        router.location.pathname.includes('thank-you')) ||
      router.location.pathname.includes('bonifico-ready-for-docs')
    ) {
      return null
    }

    const currentRoute =
      this.props.routing.locationBeforeTransitions.pathname.replace('/', '')
    const currentNavigationElements =
      this.navigationElements[`${flowType}-${payment.method}`]
    const currentFlowStep = find(
      currentNavigationElements,
      (element, routeKey) => {
        if (
          element.pages &&
          find(element.pages, page => currentRoute.includes(page))
        ) {
          return element
        }
        if (element.ignore && element.ignore.includes(currentRoute)) {
          return
        }
        if (currentRoute.includes(routeKey)) {
          return element
        }
      }
    )

    let selectedFinanziamento =
      flowType === 'buy' &&
      (payment.method === 'finanziamento' ||
        payment.method === 'finanziamento_findomestic')
        ? getSelectedFinanziamento(ordine, financements)
        : null
    if (
      selectedFinanziamento &&
      !!this.props.findomestic.finanziamentoAssicurato.id_finanziamento &&
      !!selectedFinanziamento.id_finanziamento &&
      this.props.findomestic.finanziamentoAssicurato.id_finanziamento !==
        selectedFinanziamento.id_finanziamento
    ) {
      selectedFinanziamento = this.props.findomestic.finanziamentoAssicurato
    }
    return (
      <div
        className={
          `flow-bar` +
          ` flow-bar-${currentRoute}${!currentFlowStep ? ' --restricted' : ''}${
            router.location.pathname.includes('register') && flowType === 'rent'
              ? ' rent-first-step'
              : ''
          }`
        }
      >
        {!!currentFlowStep && (
          <h4>
            {`${currentFlowStep.step}/${
              Object.keys(currentNavigationElements).length
            }: ${currentFlowStep.title}`}
          </h4>
        )}
        {!!currentFlowStep && (
          <div className="flow-indicators-wrapper">
            {map(currentNavigationElements, (element, routeKey) => (
              <span
                className={`flow-indicator ${
                  currentFlowStep.step >= element.step ? 'active' : ''
                }`}
                key={routeKey}
              >
                <CheckPoint />
              </span>
            ))}
          </div>
        )}

        {router.location.pathname.includes('register') &&
          flowType === 'rent' && <h3>Noleggia la tua nuova auto!</h3>}

        {router.location.pathname.includes('register') &&
          flowType === 'buy' && <h3>Acquista la tua prossima auto!</h3>}

        {!!product.id_auto && (
          <div className="cart__container">
            <div className={`cart cart-${currentRoute}`}>
              <img
                onError={() => {
                  this.setState({
                    product_image: productImagePlaceholder,
                  })
                }}
                src={this.state.product_image}
              />
              <div className={'product-detail'}>
                <span className="brand">
                  {product.marca}{' '}
                  {product.modello === product.marca
                    ? product.allestimento_breve
                    : product.modello}
                </span>
                <span className="details">
                  {`${product.alimentazione} - ${product.motorizzazione}`}
                </span>
                <div className={'minor-details-wrapper'}>
                  {nlt.selectedCanone &&
                  nlt.selectedCanone.anticipo !== null &&
                  flowType === 'buy' &&
                  !isNltBrumbrum(product) ? (
                    <span className="minor-details">
                      <span>
                        {numeral(nlt.selectedCanone.km_inclusi).format(
                          '0[,]00'
                        )}{' '}
                        Km
                      </span>
                      <span>
                        {String(product.mese).padStart(2, '0')}-{product.anno}
                      </span>
                    </span>
                  ) : null}

                  {nlt.selectedCanone &&
                  nlt.selectedCanone.anticipo !== null &&
                  flowType === 'rent' ? (
                    <span className="minor-details details-rent">
                      <span>
                        <small>€</small>
                        {numeral(
                          getFromFee('canone_mensile', nlt.selectedCanone, {
                            addCapKm: isNltBrumbrum(product),
                            plusServicesCost: nlt.serviziPlusCosto,
                          })
                        ).format('0,0[.]00')}
                      </span>
                      <span>al mese, IVA incl</span>
                    </span>
                  ) : null}

                  {(!nlt.selectedCanone || flowType === 'buy') && (
                    <span className="minor-details">
                      <span>
                        {`${formatCilindrata(product.cilindrata)} ${
                          product.alimentazione
                        }`}
                      </span>
                      <span>{product.cambio}</span>
                    </span>
                  )}
                  {selectedFinanziamento && (
                    <span className="minor-details">
                      {getSelectedFinanziamento(ordine, financements) && (
                        <span className={'info-detail'}>
                          TAN fisso{' '}
                          {numeral(selectedFinanziamento.tan / 100).format(
                            '0.00%'
                          )}
                        </span>
                      )}

                      {getSelectedFinanziamento(ordine, financements) && (
                        <span className={'info-detail'}>
                          TAEG{' '}
                          {numeral(selectedFinanziamento.taeg / 100).format(
                            '0.00%'
                          )}
                        </span>
                      )}
                      <span className={'info-detail'}>
                        {numeral(selectedFinanziamento.importo_rata).format(
                          '$ 0,0[.]00'
                        )}{' '}
                        al mese
                      </span>
                      <span
                        className={'info-detail'}
                        onClick={this.toggleRateInfo.bind(this)}
                      >
                        <i className={'icon-info'} />
                      </span>
                      {!!this.state.finanziamento_tooltip_modal && (
                        <BuyModal>
                          <div
                            className={'the-modal modal show modal-rate-box'}
                          >
                            <div
                              className="error__popup"
                              style={{ width: 'auto', minWidth: '340px' }}
                            >
                              <BuyRateBox
                                acconti={ordine.acconti}
                                calcolatrice={selectedFinanziamento}
                                handleHover={() => {}}
                                hideButton
                                keyy={selectedFinanziamento.id_finanziamento}
                                label={null}
                                numeroRate={selectedFinanziamento.numero_rate}
                                selected={0}
                                style={{ width: '100%' }}
                              />

                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  width: '100%',
                                }}
                              >
                                <BuyButton
                                  classes={'btn btn-secondary'}
                                  label={'CHIUDI'}
                                  update={this.toggleRateInfo.bind(this)}
                                />
                              </div>
                            </div>
                          </div>
                        </BuyModal>
                      )}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {router.location.pathname.includes('register') &&
        flowType === 'rent' &&
        !isNltBrumbrum(this.props.product) ? (
          <div className={'next-steps'}>
            <h4>I vantaggi del noleggio</h4>
            <ul>
              <li>
                <i className={'icon-check-bold'} />
                Assicurazione, manutenzione e assistenza incluse!
              </li>
              <li>
                <i className={'icon-check-bold'} />
                Un solo canone! Scopri le migliori proposte ad anticipo 0.
              </li>
              <li>
                <i className={'icon-check-bold'} />
                Guidi auto sempre nuove e controllate nel dettaglio!
              </li>
            </ul>
          </div>
        ) : null}
        {router.location.pathname.includes('register') &&
        flowType === 'rent' &&
        isNltBrumbrum(this.props.product) ? (
          <div className={'next-steps'}>
            <h4>I vantaggi del noleggio</h4>
            <ul>
              <li>
                <i className={'icon-check-bold'} />
                Canone fisso mensile, anche con anticipo zero per guidare sempre
                senza pensieri
              </li>
              <li>
                <i className={'icon-check-bold'} />
                Guidi poco e spendi meno: se in un mese fai pochi chilometri, il
                canone è scontato
              </li>
              <li>
                <i className={'icon-check-bold'} />
                Inclusi assicurazione, manutenzione completa e assistenza
                stradale h24
              </li>
              <li>
                <i className={'icon-check-bold'} />
                Consegna gratuita nei centri convenzionati in tutta Italia,
                disponibile in promozione la consegna a domicilio
              </li>
            </ul>
          </div>
        ) : null}

        {router.location.pathname.includes('register') &&
          flowType === 'buy' && (
            <div className={'next-steps'}>
              <h4>I vantaggi di acquistare un'auto brumbrum</h4>
              <ul>
                <li>
                  <i className={'icon-check-bold'} />
                  Prepariamo la tua auto: controllo, lavaggio e igienizzazione
                  professionale
                </li>
                <li>
                  <i className={'icon-check-bold'} />
                  La consegna avviene dove ti è più comodo
                </li>
              </ul>
            </div>
          )}
      </div>
    )
  }
}

FlowBar.propTypes = {
  flowType: PropTypes.string.isRequired,
  router: PropTypes.any.isRequired,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(FlowBar)
